import React from 'react';
import "./Footer.css";





const Footer  = ({props}) => {
  
      return (
          
<footer className="container-fluid w-100 bg-dark text-light py-3">
  <div id="footer"> 
    <div className="tableft">

      <p className="navbrand" style={{paddingTop:"20px"}}>
        
      WearOff <sub data-v-5da7d0aa="" style={{color:"#437317", paddingLeft:"-3px"}} className="mb-2 text-yellow-600">Covid19</sub>
      </p></div>
    <div className="tabcenter ni">
      <p>
      </p><table  >
        <tbody className="ni" ><tr >
            <th style={{border: "1px solid #e2e8f0"}} ><a data-v-44e2cb14="" class="ml-auto" rel="noopener noreferrer" target="_blank" href="https://twitter.com/wearoffcovid19">
        <span class="iconify" data-icon="openmoji:twitter" data-inline="false"></span>        </a>
              <br /></th>
            <th style={{border: "1px solid #e2e8f0"}}><a data-v-44e2cb14="" class='mr-auto' rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/">
                <img data-v-44e2cb14="" src="/images/facebook.png" alt="fb" class="icon"/>
        </a>
              <br /></th>
            <th style={{border: "1px solid #e2e8f0"}}><a data-v-44e2cb14="" rel="noopener noreferrer" target="_blank"
         href="">
            <span class="iconify" data-icon="logos:whatsapp" data-inline="true"></span>
        </a>
              <br /></th>
            
          </tr>
        </tbody></table>
      <p />
    </div>
    <div className="tabrigth">
     
    </div>
  </div>
</footer>




);}






export default Footer ;



// /* <footer data-v-44e2cb14="" className="soul lflex flex-wrap items-center justify-between px-4 bg-indigo-100 border-t-2 fixed bottom-0 left-0 w-ful">
//     <a data-v-44e2cb14="" href="/" class="brand-logo active-link nuxt-link-active">
        
//     </a> 
//     <div data-v-44e2cb14="" class="soul social">
        
         
        
        
        

//     <div class="ml-auto">
        
//     </div>
        
//     </div>
// </footer> */}






// // {/* <div class="footer">
// //   <div className="mytext">
// // Wear Off <sub data-v-5da7d0aa="" style={{color:"#437317", paddingLeft:"1px"}} className="mb-2 text-yellow-600">Covid19</sub>
// //  </div>
// // </div>
// //  */